module.exports = __webpack_public_path__ + "static/media/lgpd.36b09a4b.jpeg";